import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { all_routes } from "./all_routes";// adjust import path


const PublicGuard = ({ children }) =>{
  const isLoggedin = JSON.parse(sessionStorage.getItem("isLoggedin"));
  return isLoggedin ? <Navigate to={all_routes.assetmgtdashboard} replace /> : children;
};


PublicGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicGuard;
